// extracted by mini-css-extract-plugin
module.exports = {"metricContainer":"metricContainer-3m5dO","metricIcon":"metricIcon-3vu81","metricValue":"metricValue-3R_To","metricLabel":"metricLabel-3HuP4"};